import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'relay-runtime';

export const useAgentSessionsLiveUpdatesSubscription: GraphQLTaggedNode = graphql`
	subscription useAgentSessionsLiveUpdatesSubscription(
		$accountId: String!
		$cloudId: ID!
		$workspaceAri: ID!
	) {
		convoai_onInboxSessionChanged(
			accountId: $accountId
			cloudId: $cloudId
			workspaceAri: $workspaceAri
		) @optIn(to: "ConvoAiInboxSessionChanged") {
			sessionAri
			sessionId
			session {
				__typename
				...agentSessionSnapshot_session @relay(mask: false)
			}
		}
	}
`;
